<template>
  <div class="dialog">
    <el-dialog title="家庭成员" :visible.sync="familyDialogShow" width="60%" :before-close="dialogClose" @open="dialogOpen">
      <el-table :data="familyData" border style="width: 100%; max-height: 400px; overflow-y: auto">
        <el-table-column prop="familyMember" label="名称" width="100">
        </el-table-column>
        <el-table-column prop="relationship" label="与学生关系" width="100">
        </el-table-column>
        <el-table-column prop="workplace" label="工作单位" width="100">
        </el-table-column>
        <el-table-column prop="phone" label="联系电话">
        </el-table-column>
        <el-table-column label="操作" width="200px">
          <template slot-scope="scope">
            <div class="handle-container">
              <!-- 删除 -->
              <el-button type="warning" icon="el-icon-edit" size="small" @click="editFamily(scope.row)">修改</el-button>
              <!-- 删除 -->
              <el-button type="danger" icon="el-icon-delete" size="small"
                @click="delFamily(scope.row.id)">删除</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="btn-list">
        <el-button type="primary" @click="familyAdd">添加</el-button>
        <!-- <el-button type="primary" @click="confirm">保存</el-button> -->
        <!-- <el-button type="primary" plain @click="dialogClose">确认</el-button> -->
      </div>

      <!-- 添加家长 -->
      <el-dialog class="dialog" width="30%" title="添加" @open="addFormOpen" :visible.sync="addFormShow" append-to-body>
        <el-form :model="ruleAddForm" :rules="addFormRules" ref="ruleAddForm">
          <el-form-item label="姓名" label-width="100px" prop="familyMember">
            <el-input v-model="ruleAddForm.familyMember" autocomplete="off" placeholder="请输入姓名"></el-input>
          </el-form-item>
          <el-form-item label="与学生关系" label-width="100px" prop="relationship">
            <el-input v-model="ruleAddForm.relationship" autocomplete="off" placeholder="请输入与学生关系"></el-input>
          </el-form-item>
          <el-form-item label="工作单位" label-width="100px" prop="workplace">
            <el-input v-model="ruleAddForm.workplace" autocomplete="off" placeholder="请输入工作单位"></el-input>
          </el-form-item>
          <el-form-item label="电话" label-width="100px" prop="phone">
            <el-input v-model="ruleAddForm.phone" autocomplete="off" placeholder="请输入电话"></el-input>
          </el-form-item>
          <div class="btn-list">
            <el-button type="primary" plain @click="addFormSubmit">确认</el-button>
          </div>
        </el-form>
      </el-dialog>
      <!-- 修改家长 -->
      <el-dialog class="dialog" width="30%" title="修改" :visible.sync="editFormShow" append-to-body>
        <el-form :model="ruleEditForm" :rules="addFormRules" ref="ruleEditForm">
          <el-form-item label="姓名" label-width="100px" prop="familyMember">
            <el-input v-model="ruleEditForm.familyMember" autocomplete="off" placeholder="请输入姓名"></el-input>
          </el-form-item>
          <el-form-item label="与学生关系" label-width="100px" prop="relationship">
            <el-input v-model="ruleEditForm.relationship" autocomplete="off" placeholder="请输入与学生关系"></el-input>
          </el-form-item>
          <el-form-item label="工作单位" label-width="100px" prop="workplace">
            <el-input v-model="ruleEditForm.workplace" autocomplete="off" placeholder="请输入工作单位"></el-input>
          </el-form-item>
          <el-form-item label="电话" label-width="100px" prop="phone">
            <el-input v-model="ruleEditForm.phone" autocomplete="off" placeholder="请输入电话"></el-input>
          </el-form-item>
          <div class="btn-list">
            <el-button type="primary" plain @click="editFormSubmit">确认</el-button>
          </div>
        </el-form>
      </el-dialog>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: ["familyDialogShow", "familyData", "studentInfo"],
  data() {
    return {
      ruleAddForm: {
        familyMember: "",
        relationship: "",
        workplace: "",
        phone: ""
      },
      addFormRules: {
        familyMember: [
          { required: true, message: "请输入姓名", trigger: "blur" },
        ],
        relationship: [
          { required: true, message: "请输入关系", trigger: "blur" },
        ],
        phone: [
          { required: true, message: "请输入电话", trigger: "blur" },
        ],
        workplace: [{ required: true, message: "请输入工作单位", trigger: "blur" }],
      },
      addFormShow: false,
      ruleEditForm: {},
      editFormShow: false,
    };
  },
  methods: {
    editFamily(row) {
      this.ruleEditForm = row;
      this.editFormShow = true;
    },
    editFormSubmit() {
      this.$refs.ruleEditForm.validate((valid) => {
        if (valid) {
          let data = {
            id: this.ruleEditForm.id,
            studentId: this.studentInfo.id,
            ...this.ruleEditForm
          };
          this.put(this.$url.updateStudentFamily, data).then(res => {
            if (res.code == 200) {
              this.$message({
                message: "添加成功",
                type: "success",
              });
              this.editFormShow = false;
              this.$emit("updateFamilyData");
            } else {
              this.$message.error(res.msg);
            }
          })
        } else {
          return false;
        }
      });
    },
    delFamily(id) {
      this.$confirm('此操作将永久删除该家庭成员, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.delete(this.$url.deleteStudentFamilyById + '?id=' + id).then(res => {
          if (res.code == 200) {
            this.$message.success('删除成功');
            this.$emit("updateFamilyData");
          } else {
            this.$message.error(res.msg);
          }
        })
      })
    },
    addFormOpen() {
      this.ruleAddForm = {
        familyMember: "",
        relationship: "",
        workplace: "",
        phone: ""
      };
    },
    addFormSubmit() {
      this.$refs.ruleAddForm.validate((valid) => {
        if (valid) {
          console.log(this.ruleAddForm);
          let data = {
            studentId: this.studentInfo.id,
            ...this.ruleAddForm
          };
          this.post(this.$url.insertStudentFamily, data).then(res => {
            if (res.code == 200) {
              this.$message({
                message: "添加成功",
                type: "success",
              });
              this.addFormShow = false;
              this.$emit("updateFamilyData");
            } else {
              this.$message.error(res.msg);
            }
          })
        } else {
          return false;
        }
      });
    },
    familyAdd() {
      this.addFormShow = true;
    },
    confirm() {

    },
    dialogOpen() {
    },
    // 关闭弹出窗口
    dialogClose() {
      this.$emit("update:familyDialogShow", false);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./familyDialog.scss";
</style>